import React from 'react';
import { Calculator, Phone, Mail, Send, MapPin } from 'lucide-react';
import { useLang } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t
  } = useLang();
  return <footer className="bg-white text-black py-16 border-t border-neutral-100" data-id="element-104">
      <div className="container mx-auto px-6 md:px-8 max-w-7xl" data-id="element-105">
        <div className="grid md:grid-cols-4 gap-12 mb-16" data-id="element-106">
          <div className="col-span-1 md:col-span-2" data-id="element-107">
            <div className="flex items-center gap-3 mb-6" data-id="element-108">
              <Calculator className="h-6 w-6 text-black" data-id="element-109" />
              <span className="font-bold text-xl tracking-tight" data-id="element-110">
                Бухгалтер
              </span>
            </div>
            <p className="text-sm text-neutral-500 leading-relaxed max-w-xs mb-8" data-id="element-111">
              {t('footer_desc')}
            </p>

            <div className="flex flex-col gap-3" data-id="element-112">
              <a href="tel:+380500000000" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors group" data-id="element-113">
                <Phone className="h-4 w-4 group-hover:animate-pulse" data-id="element-114" />
                +380 50 000 00 00
              </a>
              <a href="https://t.me/buhgalter_ua" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors group" data-id="element-115">
                <Send className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" data-id="element-116" />
                @buhgalter_ua
              </a>
              <a href="mailto:info@buhgalter.ua" className="flex items-center gap-2 text-sm text-neutral-600 hover:text-black transition-colors" data-id="element-117">
                <Mail className="h-4 w-4" data-id="element-118" />
                info@buhgalter.ua
              </a>
              <div className="flex items-center gap-2 text-sm text-neutral-600" data-id="element-119">
                <MapPin className="h-4 w-4 flex-shrink-0" data-id="element-120" />
                м. Київ, вул. Велика Васильківська, 72
              </div>
            </div>
          </div>

          <div data-id="element-121">
            <h4 className="font-bold mb-6 text-sm uppercase tracking-wider" data-id="element-122">
              {t('footer_nav_title')}
            </h4>
            <ul className="space-y-3 text-sm text-neutral-500" data-id="element-123">
              <li data-id="element-124">
                <a href="#about" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-125">
                  {t('nav_about')}
                </a>
              </li>
              <li data-id="element-126">
                <a href="#services" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-127">
                  {t('nav_services')}
                </a>
              </li>
              <li data-id="element-128">
                <a href="#why-us" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-129">
                  {t('nav_advantages')}
                </a>
              </li>
              <li data-id="element-130">
                <a href="#faq" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-131">
                  {t('nav_faq')}
                </a>
              </li>
              <li data-id="element-132">
                <a href="#contact" className="hover:text-black transition-colors hover:translate-x-1 inline-block" data-id="element-133">
                  {t('nav_contacts')}
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-134">
            <h4 className="font-bold mb-6 text-sm uppercase tracking-wider" data-id="element-135">
              {t('footer_contacts_title')}
            </h4>
            <ul className="space-y-3 text-sm text-neutral-500" data-id="element-136">
              <li data-id="element-137">
                <a href="tel:+380500000000" className="hover:text-black transition-colors" data-id="element-138">
                  +380 50 000 00 00
                </a>
              </li>
              <li data-id="element-139">
                <a href="mailto:info@buhgalter.ua" className="hover:text-black transition-colors" data-id="element-140">
                  info@buhgalter.ua
                </a>
              </li>
              <li data-id="element-141">м. Київ, вул. Велика Васильківська, 72</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-100 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-neutral-400" data-id="element-142">
          <p data-id="element-143">
            © {new Date().getFullYear()} Бухгалтер. {t('footer_rights')}
          </p>
          <div className="flex gap-8" data-id="element-144">
            <a href="#" className="hover:text-black transition-colors" data-id="element-145">
              {t('footer_privacy')}
            </a>
            <a href="#" className="hover:text-black transition-colors" data-id="element-146">
              {t('footer_terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>;
}